export const countries = [
    'Albania',
    'Nigeria',
    'Ghana',
    'Ethiopia',
    'South Africa',
    'Zimbabwe',
    'Uganda',
    'Kenya',
    'Ivory Coast',
    'Senegal',
    'Cameroon',
    'Rwanda',
    'Rwanda',
    'Angola',
    'Madagascar',
    'Mali',
    'Guinea',
    'Tanzania',
    'DR Congo',
    'Niger',
    'Burkina Faso',
    'Mauritius',
    'Botswana',
    'Chad',
    'Mauritania',
    'Barbados',
    'Guyana',
    'Jamaica',
    'Trinidad & Tobago',
    'Haiti',
    'Dominican Republic',
    'Suriname',
    'St. Lucia',
    'Cayman Islands',
    'Bermuda',
    'Bahamas',
    'St. Vincent and the Grenadines',
    'P.R. China',
    'Hong Kong',
    'Mongolia',
    'Kazakhstan',
    'Ukraine',
    'Uzbekistan',
    'Azerbaijan',
    'Kyrgyzstan',
    'Moldova',
    'Tajikistan',
    'Georgia',
    'Armenia',
    'Belarus',
    'Finland',
    'Malawi',
    'Gambia',
    'Guinea-Bissau',
    'Mozambique',
    'Zambia',
    'Bosnia-Herzegovina',
    'Kosovo',
    'Romania',
    'Former Yugoslav Republic of Macedonia',
    'Poland',
    'Czech Republic',
    'Bulgaria',
    'France',
    'UK',
    'Greece',
    'Serbia',
    'Germany',
    'Ireland',
    'Spain',
    'Italy',
    'Austria',
    'The Netherlands',
    'Switzerland',
    'Belgium',
    'Denmark',
    'Portugal',
    'Brazil',
    'Paraguay',
    'Colombia',
    'Argentina',
    'Venezuela',
    'Guatemala',
    'Bolivia',
    'Peru',
    'Nicaragua',
    'Mexico',
    'Uruguay',
    'Panama',
    'Ecuador',
    'Costa Rica',
    'El Salvador',
    'Chile',
    'Honduras',
    'UAE',
    'Saudi Arabia',
    'Jordan',
    'Lebanon',
    'Qatar',
    'Pakistan',
    'Kuwait',
    'Bahrain',
    'Oman',
    'Iran',
    'Iraq',
    'Afghanistan',
    'Algeria',
    'Turkey',
    'USA',
    'Canada',
    'Japan',
    'Republic of Korea',
    'Samoa ',
    'New Zealand',
    'Egypt',
    'Morocco',
    'Tunisia',
    'Libya',
    'Taiwan',
    'Solomon Islands',
    'Fiji',
    'Nauru',
    'New Caledonia',
    'Tonga',
    'Papua New Guinea',
    'Vanuatu',
    'Kiribati',
    'Australia',
    'Russia',
    'Sweden',
    'Latvia',
    'Lithuania',
    'Estonia',
    'India',
    'Sri Lanka',
    'Bangladesh',
    'Nepal',
    'Bhutan',
    'Palestinian Territories',
    'Israel',
    'Maldives',
    'Indonesia',
    'Thailand',
    'Philippines',
    'Vietnam',
    'Malaysia',
    'Cambodia',
    'Singapore',
    'Myanmar',
    'Laos',
    'Brunei',
    'Malta'
]
